import { render, staticRenderFns } from "./access.icon.vue?vue&type=template&id=3ed7549a&"
import script from "./access.icon.vue?vue&type=script&lang=js&"
export * from "./access.icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports